import { AttributeBase, AttributeOptions } from './attribute-base';

export class DateAttribute extends AttributeBase<string> {
  public override controlType = 'date';
  public override options: string[] = [];
  public override type: string;

  constructor(options: AttributeOptions = {}) {
    super(options);
    this.controlType = options.type;
    this.options = options['options'] || [];
  }
}
